import { AnimatePresence, motion } from 'framer-motion';
import { useContext, useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { addIndexHtmlLinks } from '../../links/AppLinks';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { RoutesContext } from '../cnr/contexts/RoutesContext';
import PageError, { pageErrorReasonTypes } from '../components/alerts/PageError';
import { _animateTypes } from '../motions/AnimateComponent';
import ModalPage from './ModalPage';
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders';
import PageDevice from './PageDevice';

// < AppView
// AppPage
// > PageDevice
// > PageFramework
// > AppContent

/**
 * 
 * @param {object} props 
 * @returns a Route for the page
 */
const AppPage = (props) => {

  const navigate = useNavigate()

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appSettings_state, paps_state, manifest_state, currentSettings_state, transition_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { manifest } = aps_global ?? {}
  const { name: name_manifest } = manifest ?? {}
  const { transitions } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.route] : null
  const { showTransition } = transition ?? {}
  const { manifestIcons } = manifest_state ?? {}
  const { demoOverrideOn } = appSettings_state ?? {}

  const { rootPaths } = paps_state
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});

  // routesContext
  const routesContext = useContext(RoutesContext)
  const { routes_state } = routesContext ?? {}
  const { viewRoutes, genericRoutes } = routes_state ?? {}

  // pageContext 
  const { projectOptions } = aps_global ?? {}
  const { useEventViewRoutes } = projectOptions ?? {}

  // getting the routes!!!
  const _routes = genericRoutes // useEventViewRoutes ? viewRoutes : genericRoutes

  const indexRef = useRef(0);

  useEffect(() => {
    addIndexHtmlLinks(aps_global, manifest_state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestIcons, name_manifest]);

  useEffect(() => {
    if (navigate && demoOverrideOn) {
      const _aps_views = _.pickBy(aps_views, (val, key) => val.show && !key.includes('_'));
      const _aps_view_keys = _.keys(_aps_views);
      _aps_view_keys.push('landing')
      const interval = setInterval(() => {
        indexRef.current = (indexRef.current + 1) % _aps_view_keys.length;
        const _path = rootPaths.events + _aps_view_keys[indexRef.current]
        navigate(_path);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [demoOverrideOn]);

  return _routes ?
    <PageSwitch
      {...props}
      routes={_routes}
      useRouteTransitions={showTransition}
    />
    :
    <div></div>
}

/**
 * 
 * @param {object} props 
 * @returns a Route for the page
 */
const PageSwitch = (props) => {

  const pageVariants = {
    initial: { opacity: 1 }, // Start with the new page invisible
    animate: {
      opacity: 1, // Fade in the new page
      transition: {
        duration: 0.2, // Adjust duration for smooth fade-in
        ease: "easeOut"
      }
    },
    exit: {
      opacity: .9, // Fade out the old page
      transition: {
        duration: 0.2, // Match the duration to the "animate" transition for a smoother experience
        ease: "easeIn"
      }
    },
  };

  const { routes, useRouteTransitions } = props ?? {}

  const location = useLocation()
  const [trueLocation, setTrueLocation] = useState(location)
  const [previousLocation, setPreviousLocation] = useState(null);

  const _newRoute = previousLocation ? trueLocation.pathname === previousLocation.pathname : false

  const modalMode = trueLocation?.state?.modalMode

  useRenders('AppPage', true)

  useEffect(() => {
    setTrueLocation(location)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [location]);

  useEffect(() => {
    setPreviousLocation(location)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [location]);

  // const buildRoutes = (routes, index = 0) => {
  //   if (index >= routes.length) return null;

  //   const route = routes[index];

  //   const currentSegments = route.props.path
  //     .split('/')
  //     .filter(Boolean);

  //   const parentSegments =
  //     index > 0
  //       ? routes[index - 1].props.path
  //         .split('/')
  //         .filter(Boolean)
  //       : [];

  //   const path = currentSegments
  //     .slice(parentSegments.length)
  //     .join('/');

  //   return (
  //     <Route
  //       key={route.props.key}
  //       path={index === 0 ? '/' : path}
  //       element={
  //         <motion.div
  //           variants={pageVariants}
  //           initial="initial"
  //           animate="animate"
  //           exit="exit"
  //         >
  //           {route.props.element}
  //         </motion.div>
  //       }
  //     >
  //       {buildRoutes(routes, index + 1)}
  //     </Route>
  //   );
  // };

  if (trueLocation) {
    if (useRouteTransitions) {
      return (
        <AnimatePresence mode="wait" custom={previousLocation} >
          <Routes location={trueLocation} key={trueLocation.key}> {/* Use hash for key */}
            {/* {buildRoutes(routes)} */}
            {routes.map((route) => (
              <Route
                key={route.props.key} // Use route.props.key
                path={route.props.path} // Use route.props.path
                element={
                  <motion.div
                    variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                  >
                    {route.props.element} {/* Use route.props.element */}
                  </motion.div>
                }
              />
            ))}
            <Route
              path="*"
              element={
                <motion.div
                  variants={pageVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  <PageError reason={pageErrorReasonTypes.noPage} />
                </motion.div>
              }
            />
          </Routes>
        </AnimatePresence>
      )
    } else {
      return (
        <>
          {/* Main content */}
          {/* <Routes location={trueLocation} key={trueLocation.key}>
            {routes}
            <Route path="*" element={<PageError reason="noPage" />} />
          </Routes> */}

          <Routes>
            <Route path="*" element={<PageDevice />} />
          </Routes>

          {/* Modal overlay (only if modalMode is set) */}
          {modalMode && (
            <Routes>
              <Route path={trueLocation.pathname} element={<ModalPage />} />
            </Routes>
          )}
        </>
      )
    }
  }

  return <div></div>

}

export default AppPage